export const environment = {
  production: true,
  connection: {
    name: 'Holz Rentsch Softline (Test)',
    // host: 'https://softline-test.holz-rentsch.de/',
    host: location.protocol + '//' + location.hostname,
    port: Number(location.port) ?? 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
